import React, {FC, useEffect, useRef} from 'react'
import {Button} from "../inputs/Button"
import './ConfirmationDialog.less'

interface Props {
    message: string
    onConfirm: () => void
    onCancel: () => void
}

export const ConfirmationDialog: FC<Props> = ({message, onConfirm, onCancel}) => {
    const dialogRef = useRef<HTMLDivElement>(null)
    const confirmButtonRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {
        confirmButtonRef.current?.focus()

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.preventDefault()
                onCancel()
            } else if (e.key === 'Enter') {
                e.preventDefault()
                onConfirm()
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [onCancel, onConfirm])

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onCancel()
        }
    }

    return (
        <div className="confirmation-dialog-overlay" onClick={handleOverlayClick}>
            <div className="confirmation-dialog" ref={dialogRef}>
                <p>{message}</p>
                <div className="buttons">
                    <Button title="Yes" onClick={onConfirm} className="confirm-dialog-button" ref={confirmButtonRef} />
                    <Button title="No" onClick={onCancel} className="cancel-dialog-button" />
                </div>
            </div>
        </div>
    )
}
